import { post } from "../utils/backend";
import { Report, MarkAsProcessedRequest, UpdateReportResultRequest } from "../models/Report";
import { mock } from "./mock/Mock";
import { getMockData } from "./mock/Mock";
import "./mock/ReportMock";

const getUnprocessedReports = async (): Promise<Report[]> => {
    if (mock) {
        return getMockData("unprocessed_reports");
    }
    const resultOrErrorCode = await post<null, Report[]>("/managerment/report/getUnprocessedReports", null);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return [];
    }
    return resultOrErrorCode;
};

const getProcessedReports = async (): Promise<Report[]> => {
    if (mock) {
        return getMockData("processed_reports");
    }
    const resultOrErrorCode = await post<null, Report[]>("/managerment/report/getProcessedReports", null);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return [];
    }
    return resultOrErrorCode;
};

const markAsProcessed = async (params: MarkAsProcessedRequest): Promise<boolean> => {
    if (mock) {
        return true;
    }
    const resultOrErrorCode = await post<MarkAsProcessedRequest, boolean>("/managerment/report/markAsProcessed", params);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return false;
    }
    return resultOrErrorCode;
};

const updateReportResult = async (params: UpdateReportResultRequest): Promise<boolean> => {
    if (mock) {
        return true;
    }
    const resultOrErrorCode = await post<UpdateReportResultRequest, boolean>("/managerment/report/upateReportResult", params);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return false;
    }
    return resultOrErrorCode;
};

export const ReportApi = {
    getUnprocessedReports,
    getProcessedReports,
    markAsProcessed,
    updateReportResult
};